/** @format */

import React, { FC, useMemo } from 'react'
import { Card, Copy } from '@king-design/react'
import { Descriptions, DescriptionItem } from 'src/components'
import styled from 'styled-components'
import { MonitorCrumb } from 'src/components'
import { useAsync } from 'react-use'
import { getGrafanaInstanceList } from 'src/api/ApiGrafana'

const GrafanaInstanceView: FC<any> = ({ className }) => {
  // 获取资源
  const { value } = useAsync(async () => {
    const result = await getGrafanaInstanceList()
    return result?.InstancesSet?.[0] || {}
  }, [])

  // 公网地址
  const url = useMemo(() => {
    if (value) {
      const { AccessURL, AccessToken, InstanceStatus } = value
      if (InstanceStatus === 'running' && AccessURL && AccessToken) {
        return `${AccessURL}/dashboards?auth_token=${AccessToken}`
      } else {
        return '-'
      }
    }
    return '-'
  }, [value])

  return value ? (
    <div className={className}>
      <MonitorCrumb
        breadArr={[
          { title: 'Grafana服务' },
          { title: '实例信息', route: '/monitor/grafana/instancelist' },
          { title: value?.InstanceName || '实例名称' }
        ]}
      />
      <Card type="border">
        <Descriptions title="基础信息" className="base_info">
          <DescriptionItem label="运行状态">{value?.InstanceStatusDesc || '-'}</DescriptionItem>
          <DescriptionItem label="创建时间">
            {value?.InstanceStatus === 'running' ? value?.CreatedAt : '-'}
          </DescriptionItem>
          <DescriptionItem label="版本号">Grafana v11.6.0</DescriptionItem>
          <DescriptionItem span={1} className="url_item" label="公网地址">
            <p>
              <span>{url}</span>
              <Copy text={url} />
            </p>
          </DescriptionItem>
        </Descriptions>
      </Card>
    </div>
  ) : null
}

export default styled(GrafanaInstanceView)`
  .url_item {
    .k-icon {
      margin-left: 8px;
    }
  }
`
